import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  branchesDetails: {
    fontSize: 14,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(1.5),
    marginLeft: theme.spacing(2),
  },

  icon: { margin: theme.spacing(2), marginBottom: theme.spacing(1.2) },

  header: {
    fontSize: '18px',
    fontFamily: 'Source Sans Pro Semibold',
    display: 'block',
    marginBottom: theme.spacing(-1),
  },

  subHeader: { fontSize: '12px' },
})
